import React from "react";
import { Paper, Typography, Divider, Box, Skeleton } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

const BookingFareDetails = ({
  loadingFare,
  publishedFare,
  totalTaxes,
  totalFares,
  totalMealPrice,
  totalBagPrice,
}) => {
  return (
    <Paper sx={{ p: 2, borderRadius: "10px" }}>
      <Box sx={{ mt: 1 }}>
        <Box display={"flex"} flexDirection={"row"} gap={1} mb={1}>
          <InfoOutlinedIcon sx={{ color: "red" }} />
          <Typography sx={{ color: "red" }}>
            Fare may increase/update at the time of booking.
          </Typography>
        </Box>
        <Typography
          sx={{ fontFamily: "Open Sans", fontSize: "16px", fontWeight: 700 }}
        >
          Fare Details
        </Typography>
        {loadingFare ? (
          <>
            <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
            <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
            <Skeleton variant="text" width="100%" height={60} sx={{ mb: -2 }} />
          </>
        ) : (
          <Box>
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                }}
              >
                Base Fare
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {publishedFare}
              </Typography>
            </Box>

            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                }}
              >
                Taxes
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {totalTaxes}
              </Typography>
            </Box>

            {totalMealPrice ? (
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                  }}
                >
                  Meal
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  ₹ {totalMealPrice}
                </Typography>
              </Box>
            ) : (
              <Box></Box>
            )}

            {totalBagPrice ? (
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                  }}
                >
                  Bag
                </Typography>
                <Typography
                  sx={{
                    fontFamily: "Open Sans",
                    fontSize: "16px",
                    fontWeight: 700,
                  }}
                >
                  ₹ {totalBagPrice}
                </Typography>
              </Box>
            ) : (
              <Box></Box>
            )}
            <Divider sx={{ mt: 1, mb: 1 }} />
            <Box
              sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
            >
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 500,
                }}
              >
                Total
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Open Sans",
                  fontSize: "16px",
                  fontWeight: 700,
                }}
              >
                ₹ {totalFares}
              </Typography>
            </Box>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default BookingFareDetails;
